import type { AxiosRequestConfig } from 'axios';

import { auth } from '@/shared/libs/firebase';
import { ENV } from '@/shared/config';

/**
 * Get the current user's Firebase ID token for API authorization.
 * Returns null if no user is authenticated.
 */
export async function getAccessToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) {
    return null;
  }
  return user.getIdToken();
}

/**
 * Create an Axios request config with Lotus Health API authorization.
 * Throws if no user is authenticated.
 */
export async function createLotusAxiosConfig(): Promise<AxiosRequestConfig> {
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Cannot create Lotus API config: user is not authenticated');
  }

  return {
    baseURL: ENV.apiBaseUrl,
    headers: {
      Authorization: `Bearer firebase:${token}`,
    },
  };
}

export interface LotusRequestOptions {
  signal?: AbortSignal;
}

/**
 * Axios config for SDK calls (auth + baseURL + cancellation).
 */
export async function createLotusRequestConfig(
  options: LotusRequestOptions = {}
): Promise<AxiosRequestConfig> {
  const config = await createLotusAxiosConfig();
  return {
    ...config,
    signal: options.signal,
  };
}
